<div
  class="native-video-preview"
  [class.fallback-active]="!useNativePreview && !!resolvedFallbackSrc"
  [style.height]="resolvedHeight || height || null"
>
  <div
    #host
    class="native-video-preview__container"
    [class.is-hidden]="!useNativePreview"
  ></div>
  <ng-container *ngIf="!useNativePreview">
    <div class="native-video-preview__loader" *ngIf="enableSkeleton && showSkeleton">
      <p-skeleton [height]="height || '100%'" width="100%"></p-skeleton>
      <div class="native-video-preview__loader-spinner">
        <p-progressSpinner strokeWidth="4" animationDuration=".8s"></p-progressSpinner>
      </div>
    </div>
    <div
      *ngIf="resolvedFallbackSrc"
      class="native-video-preview__frame"
      [ngStyle]="fallbackFrameStyle"
      (click)="toggleFallback()"
    >
      <video
        #fallbackVideo
        class="native-video-preview__fallback"
        [class.is-hidden]="shouldUseFilteredFallbackCanvas"
        autoplay
        [loop]="loop"
        [muted]="muted"
        playsinline
        [src]="resolvedFallbackSrc"
        (loadeddata)="onFallbackLoaded()"
        (error)="onFallbackError()"
      ></video>
      <canvas
        *ngIf="shouldUseFilteredFallbackCanvas"
        #fallbackCanvas
        class="native-video-preview__fallback-canvas"
      ></canvas>
    </div>
  </ng-container>
</div>
